import { render, staticRenderFns } from "./EditorProductCard.vue?vue&type=template&id=6129f667&"
import script from "./EditorProductCard.vue?vue&type=script&lang=js&"
export * from "./EditorProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports